
import React from 'react';
import UserDetailsSection from '../../UserDetailsSection'; // Assuming this is the correct path
import { FormSection } from '../';
import { useBusinessFormContext } from '@/context/BusinessFormContext';

interface UserDetailsFormSectionProps {}

const UserDetailsFormSection: React.FC<UserDetailsFormSectionProps> = () => {
  const {
    userDetailsOpen,
    setUserDetailsOpen,
    userEmail,
    handleEmailChange,
    termsAccepted,
    handleTermsChange,
    marketingOptIn,
    handleMarketingChange,
    userDetailsComplete,
  } = useBusinessFormContext();

  return (
    <FormSection
      number={4}
      title="User Details"
      open={userDetailsOpen}
      onOpenChange={setUserDetailsOpen}
      isCompleted={userDetailsComplete} // This section's "saved" state is its completion state
      isDisabled={false} // Depends on previous sections, handled by FormSections.tsx visibility
      isComplete={false} // Validation completion //made it false cause we are not supposed to that redundant "continue" button.
      isEdited={userDetailsComplete} // Considered "edited" if complete, as there's no separate save
      hasUnsavedChanges={false} // No separate save, so no "unsaved changes" state in this manner
      onSave={() => {}} // No save action for this section wrapper
      // isProcessing={false} // No processing state for this section
    >
      <UserDetailsSection
        email={userEmail}
        handleEmailChange={handleEmailChange}
        termsAccepted={termsAccepted}
        handleTermsChange={handleTermsChange}
        marketingOptIn={marketingOptIn}
        handleMarketingChange={handleMarketingChange}
        // userDetailsComplete is not a prop for UserDetailsSection itself,
        // but its constituent parts (email, terms) are used for validation.
      />
    </FormSection>
  );
};

export default UserDetailsFormSection;
